import MuiTableCell from '@mui/material/TableCell';
import MuiTableHead from '@mui/material/TableHead';
import MuiTableRow from '@mui/material/TableRow';
import MuiTableSortLabel from '@mui/material/TableSortLabel';
import { useTheme } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import _ from 'lodash';

const TableHead = ({
  columns,
  sort,
  onChangeSort = () => {},
  formatHead = () => {},
  onSelectAll = () => {},
  rows,
  isChecked,
  numSelected,
  resetSelectAction,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const createSortHandler = (property) => () => {
    if (numSelected) dispatch(resetSelectAction());
    let body = property;
    if (_.isArray(sort)) {
      body = _.find(sort, { by: property })
        ? _.map(sort, (item) =>
            item.by === property
              ? {
                  ...item,
                  direction: item?.direction === 'asc' ? 'desc' : 'asc',
                }
              : item
          )
        : _.concat(sort, {
            by: property,
            direction: 'asc',
          });
    }

    onChangeSort(body);
  };

  return (
    <MuiTableHead>
      <MuiTableRow sx={{ backgroundColor: theme.palette.secondary.medium }}>
        {columns.map((column) => {
          const indeterminate =
            column?.checkbox &&
            column?.selectable &&
            numSelected > 0 &&
            numSelected < rows?.length;
          return (
            <MuiTableCell
              key={uuidv4()}
              align={column.align}
              sx={{
                backgroundColor: theme.palette.secondary.medium,
                minWidth: column.width || 220,
                maxWidth: column?.maxWidth,
                display: column.display,
              }}
              onClick={
                column?.checkbox && column?.selectable
                  ? () => onSelectAll(isChecked)
                  : null
              }
            >
              {column.sortable ? (
                <MuiTableSortLabel
                  active={
                    _.isArray(sort)
                      ? !!_.find(sort, (item) => item.by === column.sort_key)
                      : sort.by === column.sort_key
                  }
                  direction={
                    _.isArray(sort)
                      ? _.find(sort, (item) => item.by === column.sort_key)
                          ?.direction
                      : sort.direction
                  }
                  onClick={createSortHandler(column.sort_key)}
                >
                  {formatHead(column.key, column.label, {
                    isChecked,
                    indeterminate,
                  })}
                </MuiTableSortLabel>
              ) : (
                formatHead(column.key, column.label, {
                  isChecked,
                  indeterminate,
                })
              )}
            </MuiTableCell>
          );
        })}
      </MuiTableRow>
    </MuiTableHead>
  );
};

export default TableHead;
